import  PartnersNewList from './PartnersNewList';
export default PartnersNewList
